<template lang="pug">
div
  v-dialog(v-model="contact_owner", max-width="500")
    FormPetFound(:pet="pet")
  v-card
    v-list-item
      v-list-item-content
        v-list-item-title.headline(v-if="pet.name") {{ pet.name }}
        v-list-item-title.headline(v-else) Busco Hogar
        v-list-item-subtitle(v-if="detail") Cumpleaños: {{ pet.birthday }}
    v-img.white--text.align-end(:src="imgPet")
    v-card-text(v-if="!detail")
      v-row(align="center", justify="center")
        v-col(cols="12", sm="12")
          h1 Descripción
      v-row(align="center", justify="center")
        v-col(cols="12", sm="12")
          h3 {{ pet.description }}
    v-card-text(v-else)
      v-row(align="center", justify="center")
        v-col(cols="12", sm="12")
          h1 Información de la Mascota
      v-row(align="center", justify="center")
        v-col(cols="12", sm="6")
          v-list-item
            v-list-item-content
              v-list-item-title Color
              v-list-item-subtitle {{ pet.color }}
        v-col(cols="12", sm="6")
          v-list-item
            v-list-item-content
              v-list-item-title Peso
              v-list-item-subtitle {{ pet.weight }} Kg
      v-row(align="center", justify="center")
        v-col(cols="12", sm="6")
          v-list-item
            v-list-item-content
              v-list-item-title Raza
              v-list-item-subtitle {{ pet.race }}
        v-col(cols="12", sm="6")
          v-list-item
            v-list-item-content
              v-list-item-title Genero
              v-list-item-subtitle
              | {{ choices.gender.filter((gender) => gender.id == pet.gender)[0].name }}
      v-row(align="center", justify="center")
        v-col(cols="12", sm="6")
          v-list-item
            v-list-item-content
              v-list-item-title Tipo de Comida
              v-list-item-subtitle {{ pet.type_food }}
        v-col(cols="12", sm="6")
          v-list-item
            v-list-item-content
              v-list-item-title Especie
              v-list-item-subtitle {{ pet.specie || 'N/A' }}
      v-row(align="center", justify="center")
        v-col(cols="12", sm="6")
          v-list-item
            v-list-item-content
              v-list-item-title Esterilizado
              v-list-item-subtitle(v-if="pet.sterilized") Sí
              v-list-item-subtitle(v-else) No
        v-col(cols="12", sm="6")
          v-list-item
            v-list-item-content
              v-list-item-title Condición
              v-list-item-subtitle(v-if="pet.condition") {{ pet.condition }}
              v-list-item-subtitle(v-else) N/A
      v-row(v-if="pet.locators" align="center", justify="center")
        v-col(cols="12", sm="12")
          h1 Inventarios
      v-row(align="center", justify="center")
        v-col(
          v-for="(locator, index) in pet.locators"
          :key="index"
          cols="12",
          sm="12"
        )
          v-list-item
            v-list-item-content
              v-list-item-title {{ locator.inventory_type == "1" ? "Tag" : (locator.inventory_type == "2" ? "Chip" : " Collar" ) }}: {{ locator.code }}
      v-row(v-if="owner" align="center", justify="center")
        v-col(cols="12", sm="12")
          h1 Información Propietario
      v-row(v-if="owner" align="center", justify="center")
        v-col(cols="12", md="4", sm="12")
          v-list-item
            v-list-item-content
              v-list-item-title Nombre
              v-list-item-subtitle {{ owner.first_name ? owner.first_name : 'N/A' }} {{ owner.last_name ? owner.last_name : 'N/A' }}
        v-col(cols="12", md="4", sm="12")
          v-list-item
            v-list-item-content
              v-list-item-title Correo Electrónico
              v-list-item-subtitle {{ owner.email ? owner.email : 'N/A' }}
        v-col(cols="12", md="4", sm="12")
          v-list-item
            v-list-item-content
              v-list-item-title Teléfono
              v-list-item-subtitle {{ owner.phone_number ? owner.phone_number : 'N/A' }} - {{ owner.phone_number_mobile ? owner.phone_number_mobile : 'N/A' }}
      //- v-row(align="center", justify="center")
      //-   v-col(cols="12", sm="12")
      //-     h1 Información Veterinario
      //- v-row(align="center", justify="center")
      //-   v-col(cols="12", md="4", sm="12")
      //-     v-list-item
      //-       v-list-item-content
      //-         v-list-item-title Nombre
      //-         v-list-item-subtitle Dr. {{ vet.first_name }} {{ vet.last_name }}
      //-   v-col(cols="12", md="4", sm="12")
      //-     v-list-item
      //-       v-list-item-content
      //-         v-list-item-title Correo Electrónico
      //-         v-list-item-subtitle Dr. {{ vet.email }}
      //-   v-col(cols="12", md="4", sm="12")
      //-     v-list-item
      //-       v-list-item-content
      //-         v-list-item-title Teléfono
      //-         v-list-item-subtitle {{ vet.phone_number }} - {{ vet.phone_number_mobile }}
    v-card-actions(v-if="button_contact")
      v-spacer
      v-btn(text, color="secondary", @click="contact_owner = true") Contactar Dueño
</template>

<script>
import utils from "@/resources/utils";
import { mapGetters, mapState } from "vuex";
import FormPetFound from "@/components/pets/FormPetFound.vue";

export default {
  props: {
    detail: {
      type: Boolean,
      required: false,
      default: false
    },
    pet: {
      type: Object,
      required: true
    },
    owner: {
      type: Object,
      required: false,
      default: () => {}
    },
    vet: {
      type: Object,
      required: false,
      default: () => {}
    },
    button_contact: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  components: {
    FormPetFound
  },
  computed: {
    ...mapState({
      auth_token: state => state.auth.auth_token
    }),
    ...mapGetters({
      choices: "selectChoices"
    }),
    imgPet() {
      return utils.validateImages(this.pet.picture);
    },
  },
  data() {
    return {
      contact_owner: false
    };
  }
};
</script>
